import { render } from "./myPurse.vue?vue&type=template&id=10a7162c&scoped=true"
import script from "./myPurse.vue?vue&type=script&lang=js"
export * from "./myPurse.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Code\\mt\\hql\\bm\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10a7162c"]])

export default __exports__